'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
require('styled-components');
var _babelHelpers = require('../_babelHelpers-48e7a7f7.js');
require('../settings-9ee2f03f.js');
var sharedComponents = require('../shared-components.js');
require('lodash/camelCase');
require('../style-222d2b0f.js');
require('../typography/b14.js');
require('../polished.es-a11ee845.js');
var omit = _interopDefault(require('lodash/omit'));
var style$2 = require('../style-17209f53.js');
require('../typography/b18.js');
require('../typography/b16.js');
var radioButton = require('./radio-button.js');
var isNil = _interopDefault(require('lodash/isNil'));
var isFunction = _interopDefault(require('lodash/isFunction'));

var RadioGroupWithConditionalFields = function (_React$Component) {
  _babelHelpers.inherits(RadioGroupWithConditionalFields, _React$Component);

  function RadioGroupWithConditionalFields() {
    _babelHelpers.classCallCheck(this, RadioGroupWithConditionalFields);
    return _babelHelpers.possibleConstructorReturn(this, (RadioGroupWithConditionalFields.__proto__ || Object.getPrototypeOf(RadioGroupWithConditionalFields)).apply(this, arguments));
  }

  _babelHelpers.createClass(RadioGroupWithConditionalFields, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _props = this.props,
          name = _props.name,
          values = _props.values,
          hiddenFieldNames = _props.hiddenFieldNames,
          choices = _props.choices,
          setFieldValue = _props.setFieldValue;

      var nextValue = nextProps.values;
      if (hiddenFieldNames && values[name] !== nextValue[name]) {
        // if selectingChoice is not showHidden
        var selectingChoices = choices.filter(function (c) {
          return c.value === nextValue[name];
        })[0];
        var hiddenFieds = hiddenFieldNames;
        if (!Array.isArray(hiddenFieldNames)) hiddenFieds = [hiddenFieds];
        if (selectingChoices && !selectingChoices.showHidden) {
          // this is the state where it change from show the field to hide it
          this.hiddenFieldsValue = hiddenFieds.map(function (fieldName) {
            setFieldValue(fieldName, Array.isArray(values[fieldName]) ? [] : undefined, false);
            return { key: fieldName, value: values[fieldName] };
          });
        } else if (this.hiddenFieldsValue && Array.isArray(this.hiddenFieldsValue)) {
          this.hiddenFieldsValue.forEach(function (_ref) {
            var key = _ref.key,
                value = _ref.value;

            setFieldValue(key, value);
          });
        }
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _props2 = this.props,
          choices = _props2.choices,
          name = _props2.name,
          handleChange = _props2.handleChange,
          handleBlur = _props2.handleBlur,
          children = _props2.children,
          isChecked = _props2.isChecked,
          values = _props2.values,
          error = _props2.error,
          ErrorMessageStyle = _props2.ErrorMessageStyle,
          underRadioRender = _props2.underRadioRender,
          hideChoices = _props2.hideChoices,
          id = _props2.id,
          groupClassName = _props2.groupClassName,
          props = _babelHelpers.objectWithoutProperties(_props2, ["choices", "name", "handleChange", "handleBlur", "children", "isChecked", "values", "error", "ErrorMessageStyle", "underRadioRender", "hideChoices", "id", "groupClassName"]);

      return React__default.createElement(
        "div",
        groupClassName ? { className: groupClassName } : {},
        !hideChoices && React__default.createElement(
          style$2.RadioGroup,
          null,
          choices.map(function (choice) {
            return React__default.createElement(radioButton, _babelHelpers._extends({
              key: choice.id,
              id: isNil(id) ? "" + choice.id : id + "_" + choice.id,
              name: name,
              choice: choice,
              onChange: handleChange,
              onBlur: handleBlur,
              value: choice.value,
              error: error,
              checked: isChecked(choice.value, values[name])
            }, omit(props, ["id"])));
          }),
          error && React__default.createElement(
            sharedComponents.ErrorMessage,
            {
              ErrorMessageStyle: _babelHelpers._extends({ marginTop: "10px" }, ErrorMessageStyle) },
            error
          )
        ),
        isFunction(underRadioRender) && underRadioRender(),
        choices.map(function (choice) {
          if (isChecked(choice.value, values[name]) && choice.showHidden) {
            return children;
          }
          return null;
        })
      );
    }
  }]);
  return RadioGroupWithConditionalFields;
}(React__default.Component);

RadioGroupWithConditionalFields.propTypes = {
  /** The array of choice use for render radio button */
  choices: PropTypes.array.isRequired,
  /** Name of radio button field */
  name: PropTypes.string.isRequired,
  /** handleChange function from formik */
  handleChange: PropTypes.func.isRequired,
  /** handleBlur function from formik */
  handleBlur: PropTypes.func.isRequired,
  /** Function to validate that radio button is selected */
  isChecked: PropTypes.func,
  /** Values object from formik */
  values: PropTypes.oneOfType([PropTypes.object, PropTypes.string]).isRequired,
  /** Name of field in the children component */
  hiddenFieldNames: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /** setFieldValue function from formik */
  setFieldValue: PropTypes.func.isRequired,
  /** Use for increase label size to 18 px */
  large: PropTypes.bool,
  /** Error message when it fail in validation */
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /** Error message style object */
  ErrorMessageStyle: PropTypes.object,
  /** Component at under radio */
  underRadioRender: PropTypes.func,
  /** Radio group class name */
  groupClassName: PropTypes.string
};
RadioGroupWithConditionalFields.defaultProps = {
  isChecked: function isChecked(choiceValue, currentValue) {
    return choiceValue === currentValue;
  }
};
RadioGroupWithConditionalFields.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "RadioGroupWithConditionalFields",
  "props": {
    "isChecked": {
      "defaultValue": {
        "value": "(choiceValue, currentValue) => choiceValue === currentValue",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Function to validate that radio button is selected"
    },
    "choices": {
      "type": {
        "name": "array"
      },
      "required": true,
      "description": "The array of choice use for render radio button"
    },
    "name": {
      "type": {
        "name": "string"
      },
      "required": true,
      "description": "Name of radio button field"
    },
    "handleChange": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "handleChange function from formik"
    },
    "handleBlur": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "handleBlur function from formik"
    },
    "values": {
      "type": {
        "name": "union",
        "value": [{
          "name": "object"
        }, {
          "name": "string"
        }]
      },
      "required": true,
      "description": "Values object from formik"
    },
    "hiddenFieldNames": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "array"
        }]
      },
      "required": false,
      "description": "Name of field in the children component"
    },
    "setFieldValue": {
      "type": {
        "name": "func"
      },
      "required": true,
      "description": "setFieldValue function from formik"
    },
    "large": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Use for increase label size to 18 px"
    },
    "error": {
      "type": {
        "name": "union",
        "value": [{
          "name": "string"
        }, {
          "name": "object"
        }]
      },
      "required": false,
      "description": "Error message when it fail in validation"
    },
    "ErrorMessageStyle": {
      "type": {
        "name": "object"
      },
      "required": false,
      "description": "Error message style object"
    },
    "underRadioRender": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Component at under radio"
    },
    "groupClassName": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "Radio group class name"
    }
  }
};

module.exports = RadioGroupWithConditionalFields;
//# sourceMappingURL=radio-conditional-field.js.map
